import { createElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { creerContexte } from './contexte.js';
import { Document } from './html/Document.js';
import { resoudre } from './routes.js';
import { meta } from './tete.js';
import { theme as themeParNom } from './themes/index.js';
export function resoudreTheme(theme) {
    return typeof theme === 'string' ? themeParNom(theme) : theme;
}
/** Tout chemin de page se termine par une barre oblique. */
export function normaliserChemin(chemin) {
    const avecBarre = chemin.startsWith('/') ? chemin : `/${chemin}`;
    return avecBarre.endsWith('/') ? avecBarre : `${avecBarre}/`;
}
/**
 * Rend une page du site d'une galerie (section 7.3).
 *
 * Fonction **pure** : mêmes entrées, même sortie, sans horloge, sans réseau,
 * sans disque. Un chemin inconnu rend la page 404 plutôt que de lever.
 */
export function render(theme, siteData, langue, chemin) {
    const normalise = normaliserChemin(chemin);
    return rendreVue(theme, siteData, langue, normalise, resoudre(siteData, langue, normalise));
}
/** Rend une vue déjà résolue : sert au 404 et à l'aperçu de la régie. */
export function rendreVue(theme, siteData, langue, chemin, vue) {
    const resolu = resoudreTheme(theme);
    const ctx = creerContexte(siteData, langue, chemin, vue);
    const corps = renderToStaticMarkup(createElement(Document, { ctx, meta: meta(ctx), theme: resolu }));
    return `<!DOCTYPE html>\n${corps}\n`;
}
//# sourceMappingURL=render.js.map